// Value rules for a "circle" field in the filler. Circle one stores the option
// text ("" for none); circle all that apply stores an array of option texts.
type CircleField = { options?: string[]; multiple?: boolean };

const same = (a: unknown, b: unknown) => String(a ?? "").trim().toLowerCase() === String(b ?? "").trim().toLowerCase();

export function circledOptions(value: unknown): string[] {
  if (Array.isArray(value)) return value.map(String);
  return value ? [String(value)] : [];
}

export function isCircled(value: unknown, option: string): boolean {
  return circledOptions(value).some((v) => same(v, option));
}

// Clicking an option: circles it, or un-circles it if it already is. On a
// circle-one field, circling a different option replaces the first.
export function toggleCircleOption(field: CircleField, value: unknown, option: string): string | string[] {
  const on = isCircled(value, option);
  if (field.multiple) {
    const rest = circledOptions(value).filter((v) => !same(v, option));
    const next = on ? rest : [...rest, option];
    // keep the form's own order so the saved value reads the same every time
    return (field.options ?? []).filter((o) => next.some((v) => same(v, o)));
  }
  return on ? "" : option;
}

export function hasCircleValue(value: unknown): boolean {
  return circledOptions(value).length > 0;
}
